(function() {
	/**
	 * Render 404 not found Page
	 * @param {object} props - The Routing context
	 * @returns {object} Promise
	 */
	WebBaseAprovLV.render404 = function(props) {
		return WebBaseAprovLV.Utils.transitionTo({
			element: $('#content'),
			template: 'templates/404.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {}
		});
	};
})();
